<template>
  <div class="threerouter">
    <transition name="el-fade-in-linear">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'threeRouter',
  data() {
    return{
      tableData: []
    }
  },
  methods: {
    getData() {
    }
  }
}
</script>